module.exports = __webpack_public_path__ + "img/p5-desc.7acbab44.jpg";